module.exports = __webpack_public_path__ + "static/img/pc_lx_contact_content2_ig.223e8b0.png";